export default __webpack_public_path__ + "07711f2936b37bf26be71cc2d6f84724.svg";